export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen min-h-[700px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5b06c83827391123b1a7e7adbed64e7b.jpg"
          alt="ATMOS Empreendimento"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 w-full">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg mb-6">
            <span className="text-white text-xs font-semibold uppercase tracking-wider">
              Linha VOLT - ATR Incorporadora
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-serif font-bold text-5xl lg:text-7xl text-white leading-tight mb-6">
            Studios e Compactos no Centro de Curitiba
          </h1>

          {/* Subheadline */}
          <p className="text-white/90 text-lg lg:text-xl mb-10 leading-relaxed">
            326 unidades | Estúdios, 1 e 2 quartos | Av. Visconde de Guarapuava, 2807 | Entrega: Setembro/2028
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://wa.me/5541988674555?text=Olá! Gostaria de saber mais sobre o ATMOS."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center space-x-2 bg-[#25D366] text-white px-8 py-4 rounded-full font-semibold text-base hover:bg-[#20BA5A] transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>Falar no WhatsApp</span>
            </a>
            <button
              onClick={() => scrollToSection('contato')}
              className="inline-flex items-center justify-center space-x-2 border-2 border-white bg-transparent text-white px-8 py-4 rounded-full font-semibold text-base hover:bg-white hover:text-primary transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Receber Tabela e Disponibilidade</span>
              <i className="ri-arrow-down-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Proof Card */}
      <div className="absolute bottom-12 right-12 hidden lg:block z-10">
        <div className="bg-white/20 backdrop-blur-md rounded-2xl p-6 border border-white/30">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-white/30 rounded-full flex items-center justify-center">
              <i className="ri-building-2-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-bold text-2xl">326</p>
              <p className="text-white/80 text-sm">unidades</p>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-white/30">
            <p className="text-white/90 text-sm">
              <i className="ri-calendar-line mr-2"></i>
              Entrega Set/2028
            </p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <button
          onClick={() => scrollToSection('conceito')}
          className="animate-bounce cursor-pointer"
          aria-label="Rolar para baixo"
        >
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
